var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipgrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 32,
    viewBox: "0 0 145 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8066 18.738L28.6621 18.5932L41.9012 2.68651C41.9155 2.73589 41.9252 2.78652 41.9301 2.83772C41.9301 3.6485 41.9301 4.44641 41.9301 5.27006C41.9256 5.3561 41.8916 5.43795 41.8337 5.50171C40.7032 6.65996 39.5705 7.81715 38.4356 8.97326L35.5482 11.9043C34.2314 13.247 32.9135 14.5865 31.5945 15.9228C30.7616 16.77 29.9286 17.6173 29.0957 18.4645C29.009 18.5449 28.9062 18.6286 28.8066 18.738Z",
    fill: "url(#paint0_linear_3481_149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0439 18.8989L41.0175 7.27454C41.0175 7.42254 41.0175 7.51262 41.0175 7.59627C41.0175 8.06923 41.0175 8.5454 41.0175 9.02157C41.0126 9.14348 40.9608 9.25875 40.873 9.34331C38.8903 10.9949 36.9096 12.6433 34.9312 14.2884C33.0705 15.837 31.2108 17.3846 29.3523 18.9311C29.227 19.0244 29.1499 19.0855 29.0439 18.8989Z",
    fill: "url(#paint1_linear_3481_149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.942 10.8779C39.942 11.4378 39.942 11.9268 39.942 12.4126C39.9217 12.4706 39.8805 12.5189 39.8263 12.5478L35.651 15.3244L30.9778 18.442C30.5507 18.7251 30.1203 19.005 29.6931 19.2914C29.5678 19.3782 29.494 19.3525 29.4201 19.2174L39.942 10.8779Z",
    fill: "url(#paint2_linear_3481_149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8154 19.5359L38.3074 14.2529C38.3074 14.7355 38.2849 15.1731 38.3074 15.6074C38.3215 15.6991 38.301 15.7927 38.2499 15.87C38.1988 15.9473 38.1209 16.0028 38.0312 16.0257C35.404 17.2118 32.7778 18.4055 30.1527 19.6066C30.0274 19.6646 29.9054 19.7353 29.8154 19.5359Z",
    fill: "url(#paint3_linear_3481_149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0373 23.194H69.8438C67.5378 23.194 66.3837 21.461 66.3815 17.9948C66.3794 14.5286 67.5335 12.7933 69.8438 12.7891H78.5157L81.9748 5.8524H69.8438C62.9192 5.8524 59.4569 9.89986 59.4569 17.9948C59.4569 26.0897 62.9192 30.1361 69.8438 30.1339H81.962V17.9948H75.0373V23.194Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.152 22.261C104.721 20.9998 106.02 18.4592 106.048 14.6391C106.055 13.488 105.835 12.347 105.4 11.2814C104.966 10.2159 104.325 9.24699 103.515 8.43039C102.705 7.6138 101.742 6.96564 100.682 6.52322C99.6207 6.08079 98.4831 5.85282 97.334 5.85242H85.2705V12.7891H97.3886C98.5449 12.7891 99.1219 13.3703 99.1198 14.5329C99.1105 14.9971 98.9188 15.439 98.5862 15.7625C98.2537 16.0859 97.8072 16.265 97.3437 16.2606H85.2705V30.1339H92.1952V19.7289L99.5662 30.1339H108.238L102.152 22.261Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.482 5.8524H109.558V30.1307H116.482V5.8524Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.289 5.85559H121.178V30.1339H133.289C140.214 30.1339 143.676 26.0875 143.676 17.9947C143.676 9.90197 140.214 5.85559 133.289 5.85559ZM133.289 23.1972H128.102V12.789H133.289C135.596 12.789 136.75 14.5243 136.752 17.9947C136.754 21.4652 135.6 23.1994 133.289 23.1972Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0775 13.9473C22.0522 13.5518 22.0007 13.1584 21.9233 12.7697C21.8646 12.4776 21.7906 12.1887 21.7017 11.9043C21.1428 10.1477 20.0404 8.61486 18.5542 7.52747C17.068 6.44008 15.275 5.85455 13.4345 5.85559H1.31641V30.1339H8.24105V23.1972H13.4345C18.3893 23.1972 21.2157 21.0652 21.9137 16.8011C21.9683 16.4987 22.0036 16.1866 22.0325 15.8616C22.0486 15.6975 22.0582 15.5399 22.0679 15.3694C22.0839 15.0895 22.0903 14.7999 22.0903 14.5039V14.3881C22.0903 14.2369 22.0839 14.0921 22.0775 13.9473ZM13.3864 16.2606H8.24747V12.789H13.4345C14.5876 12.789 15.1689 13.3714 15.1657 14.5328C15.1556 14.9974 14.9631 15.4392 14.6301 15.7626C14.297 16.086 13.8502 16.2649 13.3864 16.2606Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 7.5447H32.0155V6.7854C32.0155 6.52941 31.914 6.28391 31.7333 6.10289C31.5526 5.92188 31.3075 5.82019 31.052 5.82019H25.8745C25.619 5.82019 25.3739 5.92188 25.1932 6.10289C25.0125 6.28391 24.911 6.52941 24.911 6.7854V7.87287H24.8339C24.7749 7.87372 24.7185 7.89782 24.677 7.93997C24.6355 7.98211 24.6123 8.03891 24.6123 8.09809V9.00861C24.6123 9.06749 24.6357 9.12395 24.6772 9.16558C24.7188 9.20722 24.7751 9.23061 24.8339 9.23061H24.911V11.412C24.911 11.668 25.0125 11.9135 25.1932 12.0945C25.3739 12.2755 25.619 12.3772 25.8745 12.3772H31.0455C31.3011 12.3772 31.5462 12.2755 31.7269 12.0945C31.9076 11.9135 32.0091 11.668 32.0091 11.412V9.56843H30.8657V7.81818C30.8661 7.78101 30.8739 7.74429 30.8888 7.71023C30.9037 7.67617 30.9252 7.64546 30.9522 7.61994C30.9792 7.59441 31.011 7.57459 31.0458 7.56167C31.0806 7.54874 31.1177 7.54297 31.1547 7.5447ZM27.8241 7.81818C27.8241 7.74565 27.8529 7.67609 27.9041 7.6248C27.9553 7.57352 28.0247 7.5447 28.0971 7.5447H29.0607C29.1331 7.5447 29.2025 7.57352 29.2537 7.6248C29.3049 7.67609 29.3337 7.74565 29.3337 7.81818V9.56843H27.808L27.8241 7.81818ZM31.0359 10.7363C31.0478 10.7363 31.0593 10.7411 31.0677 10.7495C31.0761 10.758 31.0809 10.7694 31.0809 10.7814V11.0356C31.0813 11.0679 31.0753 11.1001 31.0632 11.1301C31.0511 11.1602 31.0332 11.1875 31.0105 11.2105C30.9878 11.2336 30.9608 11.2519 30.9309 11.2644C30.9011 11.2769 30.8691 11.2833 30.8368 11.2833H29.3915C29.3591 11.2833 29.3271 11.2769 29.2973 11.2644C29.2675 11.2519 29.2404 11.2336 29.2177 11.2105C29.195 11.1875 29.1771 11.1602 29.165 11.1301C29.1529 11.1001 29.1469 11.0679 29.1474 11.0356V10.7814C29.1469 10.7756 29.1477 10.7698 29.1496 10.7644C29.1515 10.7589 29.1545 10.7539 29.1584 10.7497C29.1623 10.7455 29.1671 10.7421 29.1724 10.7398C29.1777 10.7375 29.1834 10.7363 29.1891 10.7363H31.0359Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9714 13.4615H25.9514C25.6958 13.4615 25.4507 13.5632 25.27 13.7442C25.0893 13.9252 24.9878 14.1707 24.9878 14.4267V26.6656C24.9737 27.1297 25.0528 27.592 25.2203 28.025C25.3879 28.4579 25.6406 28.8528 25.9633 29.1861C26.2861 29.5194 26.6723 29.7844 27.0992 29.9653C27.5261 30.1463 27.985 30.2395 28.4485 30.2395C28.9121 30.2395 29.3709 30.1463 29.7978 29.9653C30.2247 29.7844 30.611 29.5194 30.9338 29.1861C31.2565 28.8528 31.5092 28.4579 31.6767 28.025C31.8443 27.592 31.9234 27.1297 31.9093 26.6656V14.4171C31.9068 14.1671 31.8078 13.9279 31.6328 13.7497C31.4579 13.5715 31.2208 13.4681 30.9714 13.4615Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2011 5.85235H37.083V12.789H49.2011C50.3574 12.789 50.9344 13.3703 50.9323 14.5328C50.923 14.9971 50.7313 15.4389 50.3987 15.7624C50.0662 16.0859 49.6197 16.2649 49.1562 16.2606H37.083V30.1339H44.0012V23.194H49.1947C55.0145 23.194 57.9051 20.2576 57.8666 14.3848C57.8353 12.106 56.9076 9.93153 55.2851 8.33389C53.6626 6.73626 51.4762 5.8445 49.2011 5.85235Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4947 5.37939C27.7014 5.37939 25.1191 5.33757 25.1191 4.8067C25.1191 4.27583 27.6886 4.23401 28.4947 4.23401C29.3009 4.23401 31.8671 4.27583 31.8671 4.8067C31.8671 5.33757 29.2848 5.37939 28.4947 5.37939ZM25.4339 4.8067C25.7101 4.94505 26.815 5.10592 28.4947 5.10592C30.1745 5.10592 31.2762 4.94505 31.5524 4.8067C31.2762 4.67157 30.1713 4.50749 28.4947 4.50749C26.8182 4.50749 25.7101 4.67157 25.4339 4.8067Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6215 17.9176L27.7692 17.776L14.5366 1.86929C14.5247 1.91907 14.5161 1.96958 14.5109 2.02051C14.5109 2.83129 14.5109 3.6292 14.5109 4.45284C14.5154 4.53889 14.5494 4.62073 14.6073 4.6845C15.7443 5.85133 16.8812 7.00851 18.0182 8.15604L20.8767 11.0774C22.1978 12.4158 23.5157 13.7553 24.8304 15.0959C25.6655 15.941 26.4984 16.7883 27.3292 17.6376L27.6215 17.9176Z",
    fill: "url(#paint4_linear_3481_149)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3967 18.0816C23.414 14.2208 19.441 10.3599 15.4199 6.45727C15.4199 6.60205 15.4199 6.69535 15.4199 6.77901C15.4199 7.25518 15.4199 7.74422 15.4199 8.20752C15.427 8.3289 15.4784 8.44341 15.5644 8.52926C17.545 10.1808 19.5299 11.8281 21.5191 13.4711L27.0883 18.1138C27.1975 18.2071 27.3003 18.265 27.3967 18.0816Z",
    fill: "url(#paint5_linear_3481_149)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 10.0607C16.4961 10.6205 16.4961 11.1063 16.4961 11.5954C16.4961 11.6468 16.5571 11.708 16.6053 11.7401L20.7806 14.5167L25.4506 17.6247C25.8778 17.9078 26.3081 18.1845 26.7353 18.4741C26.8606 18.561 26.9345 18.5352 27.0051 18.4001C23.5267 15.6332 20.0387 12.8694 16.4961 10.0607Z",
    fill: "url(#paint6_linear_3481_149)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6258 18.7187L18.1338 13.4358C18.1338 13.9184 18.1531 14.3527 18.1338 14.7903C18.1205 14.8818 18.1413 14.975 18.1923 15.0522C18.2432 15.1293 18.3208 15.185 18.41 15.2085C21.0394 16.3968 23.6656 17.5905 26.2886 18.7895C26.4106 18.8442 26.5327 18.9149 26.6258 18.7187Z",
    fill: "url(#paint7_linear_3481_149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3481_149",
    x1: 33.4991,
    y1: 7.54474,
    x2: 37.1733,
    y2: 13.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3481_149",
    x1: 34.0158,
    y1: 11.3252,
    x2: 36.1476,
    y2: 15.0156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3481_149",
    x1: 34.1961,
    y1: 14.2015,
    x2: 35.2748,
    y2: 16.0692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3481_149",
    x1: 33.9811,
    y1: 16.756,
    x2: 34.6831,
    y2: 17.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3481_149",
    x1: 14.5109,
    y1: 9.89342,
    x2: 27.7789,
    y2: 9.89342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3481_149",
    x1: 15.4134,
    y1: 12.329,
    x2: 27.3967,
    y2: 12.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3481_149",
    x1: 16.4961,
    y1: 14.2915,
    x2: 27.0115,
    y2: 14.2915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3481_149",
    x1: 18.1306,
    y1: 16.1416,
    x2: 26.6258,
    y2: 16.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipgrid);
export default __webpack_public_path__ + "static/media/Pipgrid.afe8b5a918bf1412cdcef19779977ee1.svg";
export { ForwardRef as ReactComponent };